import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield, Loader2, Eye, EyeOff } from 'lucide-react';

const API = '/api/analytics';

export default function AnalyticsLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(API + '/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || 'Erreur de connexion');
      }
      const data = await res.json();
      localStorage.setItem('analytics_token', data.token);
      navigate('/analytics/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-testid="analytics-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 bg-[#2ab540]/10 border border-[#2ab540]/30 rounded-xl flex items-center justify-center mx-auto mb-4">
            <Shield className="w-7 h-7 text-[#2ab540]" />
          </div>
          <h1 className="text-xl font-bold text-gray-900">Reco Pneus Analytics</h1>
          <p className="text-gray-500 text-sm mt-1">Tableau de bord analytique</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-xl p-6 space-y-4 shadow-sm">
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm" data-testid="analytics-login-error">{error}</p>
            </div>
          )}
          <div>
            <Label className="text-gray-600 text-xs uppercase tracking-wider">Identifiant</Label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Identifiant"
              className="mt-1 bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400"
              data-testid="analytics-username"
              required
            />
          </div>
          <div>
            <Label className="text-gray-600 text-xs uppercase tracking-wider">Mot de passe</Label>
            <div className="relative mt-1">
              <Input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mot de passe"
                className="bg-gray-50 border-gray-200 text-gray-900 placeholder:text-gray-400 pr-10"
                data-testid="analytics-password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#2ab540] hover:bg-[#239e37] text-white font-bold"
            data-testid="analytics-login-btn"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Connexion'}
          </Button>
        </form>
      </div>
    </div>
  );
}
